import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import Grid from "@mui/material/Grid";
import {useAuth} from "hooks/useAuth";
import AuthCardLayout from "../components/AuthCardLayout";

const ACCOUNT_TYPES = [
    {
        image: "/images/account-type-1.svg",
        title: "Brio în școli*",
        description: "Director, profesori și elevi",
        footer: "*Contul se adresează unităților de învățământ și centrelor de meditații.",
        path: "/login/scoala",
    },
    {
        image: "/images/account-type-2.svg",
        title: "Brio în clasă*",
        description: "Profesor și elevi",
        footer: "*Contul se adresează profesorilor individuali la clasă, independent de contul Brio dedicat unităților de învățământ.",
        path: "/login/profesori",
    },
];

const ChooseAccountType = () => {
    const {update} = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (typeof window !== "undefined") {
            const errorCode = window.localStorage.getItem("globalErrorCode");
            if (errorCode) {
                update("error", {show: true, code: errorCode});
                window.localStorage.removeItem("globalErrorCode");
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Grid container spacing={4} justifyContent="center">
            {ACCOUNT_TYPES.map((type) => (
                <AuthCardLayout
                    image={type.image}
                    title={type.title}
                    size="medium"
                    description={type.description}
                    footer={type.footer}
                    onActionClick={() => navigate(type.path)}
                    actionLabel="Autentificare"
                    key={type.title}
                />
            ))}
        </Grid>
    )
}

export default ChooseAccountType;